import { BaseObject, IBaseObject } from './BaseObject';

export interface IEtapeScenarioLight extends IBaseObject {
  actif: boolean;
}

export interface IEtapeScenario extends IBaseObject {
  actif: boolean;
  ordre: number;
  nom: string;
  idSp: number | string | undefined;
}

export class EtapeScenario extends BaseObject implements IEtapeScenario {
  actif = false;
  ordre = 0;
  nom = '';
  idSp: number | undefined;

  constructor(props?: IEtapeScenario) {
    super(props);

    if (props) {
      Object.assign(this, props);
    }
  }

  public format(idSp?: number | string): IEtapeScenario {
    const item: IEtapeScenario = {
      id: this.id,
      nom: this.nom,
      idSp: this.idSp || idSp,
      ordre: this.ordre,
      actif: this.actif,
    };

    if (item.id == null || item.id === -1) {
      // @ts-ignore
      delete item.id;
    }

    if (this.idSp && this.idSp > -1) {
      item.idSp = this.idSp;
    } else {
      delete item.idSp;
    }

    return item;
  }

  public formatForActivation(): IEtapeScenarioLight {
    return {
      id: this.id,
      actif: this.actif,
    };
  }

  public clone(withUuid?: boolean): EtapeScenario {
    const ietape: IEtapeScenario = {
      actif: this.actif,
      id: this.id,
      idSp: this.idSp,
      nom: this.nom,
      ordre: this.ordre,
    };
    if (withUuid) {
      ietape.uuid = this.uuid;
    }
    return new EtapeScenario(ietape);
  }
}
